"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT = exports.PREMIUM_SUBSCRIPTION_YEARLY_PRICE = exports.PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT = exports.PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE = exports.PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT = exports.PREMIUM_SUBSCRIPTION_MONTHLY_PRICE = void 0;
exports.PREMIUM_SUBSCRIPTION_MONTHLY_PRICE = '288 Kč';
exports.PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT = '349 Kč';
exports.PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE = '1 587 Kč';
exports.PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT = '1 920 Kč';
exports.PREMIUM_SUBSCRIPTION_YEARLY_PRICE = '2 884 Kč';
exports.PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT = '3 490 Kč';
//# sourceMappingURL=premium-subscription.js.map